import API from "utils/API";


const apiCalls = {
  addNewByEmail: async (req) => {
    try {
      // Make an API call to update data
      const response = await API.post("notify/add/item", {
        params: ({
          ...req,
        }),
      });
      // Check if the request was successful
      const decrypt = (response?.data);
      // console.log("addNewByEmail=", decrypt);

      if (decrypt?.err === 1) {
        // If the response status is not in the range 200-299, it's an error
        throw new Error("Failed to update data");
      }

      // Parse the response body as JSON
      return decrypt ?? {};
    } catch (error) {
      // Handle errors
      throw new Error(`Failed to update data: ${error.message}`);
    }
  },
  removeItems: async (req) => {
    try {
      // Make an API call to update data
      const response = await API.post("notify/remove/items", {
        params: ({
          ...req,
        }),
      });
      // Check if the request was successful
      const decrypt = (response?.data);
      // console.log("removeItems=", decrypt);

      if (decrypt?.err === 1) {
        // If the response status is not in the range 200-299, it's an error
        throw new Error("Failed to update data");
      }

      // Parse the response body as JSON
      return decrypt ?? {};
    } catch (error) {
      // Handle errors
      throw new Error(`Failed to update data: ${error.message}`);
    }
  },
};

export default apiCalls;

